/**
 * Login page component
 */

import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Form, Input, Button, Card, Typography, message, Space } from 'antd'
import { UserOutlined, LockOutlined, LoginOutlined } from '@ant-design/icons'
import { useAuthStore } from '@/stores/authStore'
import api from '@/services/api'

const { Title, Text } = Typography

interface LoginForm {
  login: string
  password: string
}

function LoginPage() {
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()
  const { setAuth } = useAuthStore()

  const onFinish = async (values: LoginForm) => {
    setLoading(true)

    try {
      const response = await api.login(values.login, values.password)
      
      // * Save auth data
      setAuth(
        response.access_token,
        response.refresh_token,
        response.operator
      )

      message.success('Успешный вход!')
      navigate('/projects')
    } catch (error: any) {
      console.error('Login error:', error)
      
      const errorMessage = error.response?.data?.detail || 'Ошибка входа'
      message.error(errorMessage)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    }}>
      <Card 
        style={{ 
          width: 400, 
          boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
          borderRadius: '12px',
        }}
      >
        <Space direction="vertical" size="large" style={{ width: '100%', textAlign: 'center' }}>
          <div>
            <Title level={2} style={{ marginBottom: 8 }}>
              AFI
            </Title>
            <Text type="secondary">
              Automated Filtering Interface
            </Text>
          </div>

          <Form
            name="login"
            onFinish={onFinish}
            autoComplete="off"
            size="large"
            layout="vertical"
          >
            <Form.Item
              name="login"
              rules={[{ required: true, message: 'Введите логин или email!' }]}
            >
              <Input 
                prefix={<UserOutlined />} 
                placeholder="Логин или email"
                autoFocus
              />
            </Form.Item>

            <Form.Item
              name="password"
              rules={[{ required: true, message: 'Введите пароль!' }]}
            >
              <Input.Password 
                prefix={<LockOutlined />} 
                placeholder="Пароль"
              />
            </Form.Item>

            <Form.Item style={{ marginBottom: 0 }}>
              <Button 
                type="primary" 
                htmlType="submit" 
                loading={loading}
                block
                icon={<LoginOutlined />}
              >
                Войти
              </Button>
            </Form.Item>
          </Form>

          <Text type="secondary" style={{ fontSize: '12px' }}>
            Вход через Victory CRM API
          </Text>
        </Space>
      </Card>
    </div>
  )
}

export default LoginPage

